module.exports = __webpack_public_path__ + "img/freestyle_academy_logo_groen.4b07a11d.png";